import React, { Component } from 'react';
import _ from 'lodash';
import Marketplace from 'components/shared/marketplace';
import styles from './styles.module.scss';

export default class ULCIndex extends Component {
  render() {
    const { match } = this.props;
    // TODO: Expand this to handle non-sensicle types
    const typeFromPath = _.get(match.params, 'type', 'services');

    return (
      <div className={styles.marketplaceIndex}>
        <div className="container">
          <div className={styles.headerContainer}>
            <div className="row">
              <div className="col-12 mb-3">
                <p className={styles.helpText}>Click for <strong>live online lessons</strong> or <strong>educators</strong> to meet your child's goals</p>
              </div>
            </div>
          </div>
          <Marketplace
            defaultType={typeFromPath}
            serviceDetailsButtonType="link"
            centerLinkPrefix="/unyted-learning-centers"
            serviceLinkPrefix="/services"
          />
        </div>
      </div>
    );
  }
}
